module.exports = __webpack_public_path__ + "static/media/rogue.3e53ce02.png";